/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaAudioSpeakerIcon16Light } from './MediaAudioSpeakerIcon16Light';
import { MediaAudioSpeakerIcon16Regular } from './MediaAudioSpeakerIcon16Regular';
import { MediaAudioSpeakerIcon16Solid } from './MediaAudioSpeakerIcon16Solid';
import { MediaAudioSpeakerIcon20Light } from './MediaAudioSpeakerIcon20Light';
import { MediaAudioSpeakerIcon20Regular } from './MediaAudioSpeakerIcon20Regular';
import { MediaAudioSpeakerIcon20Solid } from './MediaAudioSpeakerIcon20Solid';
import { MediaAudioSpeakerIcon24Regular } from './MediaAudioSpeakerIcon24Regular';
import { MediaAudioSpeakerIcon24Solid } from './MediaAudioSpeakerIcon24Solid';
import { MediaAudioSpeakerIcon32Regular } from './MediaAudioSpeakerIcon32Regular';
import { MediaAudioSpeakerIcon64Regular } from './MediaAudioSpeakerIcon64Regular';
var sizes = {
    16: {
        light: MediaAudioSpeakerIcon16Light,
        regular: MediaAudioSpeakerIcon16Regular,
        solid: MediaAudioSpeakerIcon16Solid,
    },
    20: {
        light: MediaAudioSpeakerIcon20Light,
        regular: MediaAudioSpeakerIcon20Regular,
        solid: MediaAudioSpeakerIcon20Solid,
    },
    24: {
        regular: MediaAudioSpeakerIcon24Regular,
        solid: MediaAudioSpeakerIcon24Solid,
    },
    32: {
        regular: MediaAudioSpeakerIcon32Regular,
    },
    64: {
        regular: MediaAudioSpeakerIcon64Regular,
    },
};
export var MediaAudioSpeakerIcon = forwardRef('MediaAudioSpeakerIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
